import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import { LEGAL_DOCS, PRIVACY_VERSION, PRIVACY_EFFECTIVE } from "./legalContent";

// Standalone, finalized Privacy Policy. Renders ONLY the privacy document —
// no Legal Center index, no links to other (unfinished) legal drafts, no draft notice.
export default function PrivacyPolicy() {
  useEffect(() => { window.scrollTo(0, 0); }, []);
  const doc = LEGAL_DOCS.privacy;
  return (
    <div className="min-h-screen bg-[#0C0A0A] text-[#FBF8F3] px-5 py-12" data-testid="privacy-policy-page">
      <div className="max-w-3xl mx-auto">
        <Link to="/" data-testid="privacy-home-link" className="text-[12px] text-[#9E978E] hover:text-[#D4AF37] transition-colors">← Back to DateBid</Link>
        <h1 className="font-serif text-4xl sm:text-5xl mt-5 mb-2">{doc.title}</h1>
        <p className="text-[12px] text-[#9E978E] mb-8" data-testid="privacy-meta">
          Version {PRIVACY_VERSION} · {PRIVACY_EFFECTIVE}
        </p>
        <div className="space-y-7">
          {doc.sections.map((s, i) => (
            <section key={i} data-testid={`privacy-section-${i}`}>
              <h2 className="text-lg text-[#C9A96E] mb-1.5">{s.h}</h2>
              <p className="text-sm leading-relaxed text-[#D8D2C9]">{s.b}</p>
            </section>
          ))}
        </div>
      </div>
    </div>
  );
}
